<template>
    <UButton
      :label="likesCount.toString()"
      :color="reviewLiked ? 'success' : 'neutral'"
      :variant="reviewLiked ? 'solid' : 'outline'"
      :disabled="pending || !customerStore.customer"
      @click="reviewLiked ? handleDislike() : handleLike()"
      icon="i-heroicons-hand-thumb-up-solid"
      />
</template>
<script setup lang="ts">
const {
  reviewId,
  likes = 0,
  liked
} = defineProps<{
  reviewId: number;
  likes: number;
  liked: boolean;
}>();

const reviewLiked = ref(liked);

const likesCount = ref(likes);

const catalogService = useCatalogService();
const customerStore = useCustomerStore()

const pending = ref(false);

const toast = useToast();

const handleLike = async () => {
  pending.value = true;
  reviewLiked.value = true;

  try {
    await catalogService.likeReview(reviewId);
    likesCount.value += 1;
  } catch (error) {
    console.error('Error liking review:', error);
    toast.add({
      color: 'error',
      title: 'Error',
      description: "Couldn't like the review. Please try again later."
    });

    reviewLiked.value = false;
  } finally {
    pending.value = false;
  }
};

const handleDislike = async () => {
  pending.value = true;
  reviewLiked.value = false;

  try {
    await catalogService.unlikeReview(reviewId);
    likesCount.value -= 1;
  } catch (error) {
    console.error('Error disliking review:', error);
    toast.add({
      color: 'error',
      title: 'Error',
      description: "Couldn't dislike the review. Please try again later."
    });

    reviewLiked.value = true;
  } finally {
    pending.value = false;
  }
};
</script>